import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../';

export const selectCategories = (state: RootState) => state.faq.categories;
export const selectTopics = (state: RootState) => state.faq.topics;
export const selectCategoriesLoading = (state: RootState) => state.faq.categoriesLoading;
export const selectTopicsLoading = (state: RootState) => state.faq.topicsLoading;

export const categoryBySlugSelector = createSelector(
  [selectCategories, (_, slug) => slug],
  (categories, slug) => categories.find((el) => el.slug === slug),
);

export const topicsByCategorySlugSelector = createSelector(
  [selectTopics, (_, categorySlug) => categorySlug],
  (topics, categorySlug) => topics[categorySlug] || [],
);

export const topicsLoadingByCategorySlugSelector = createSelector(
  [selectTopicsLoading, (_, categorySlug) => categorySlug],
  (topicsLoading, categorySlug) => topicsLoading[categorySlug] ?? true,
);

export const topicBySlugSelector = createSelector(
  [topicsByCategorySlugSelector, (_, __, topicSlug) => topicSlug],
  (topics, topicSlug) => topics.find(topic => topic.slug === topicSlug),
);
